import { pgTable, uuid, text, timestamp, index } from "drizzle-orm/pg-core";
import { orders } from "./orders.js";

export const orderStatusHistory = pgTable(
  "order_status_history",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    orderId: uuid("order_id")
      .notNull()
      .references(() => orders.id, { onDelete: "cascade" }),
    field: text("field").notNull().$type<"status" | "payment_status">(),
    fromValue: text("from_value"),
    toValue: text("to_value").notNull(),
    changedBy: uuid("changed_by"),
    changedByKind: text("changed_by_kind").$type<"admin" | "customer" | "system">(),
    note: text("note"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    orderIdx: index("order_status_history_order_id_idx").on(t.orderId, t.createdAt),
  })
);

export type OrderStatusHistory = typeof orderStatusHistory.$inferSelect;
export type NewOrderStatusHistory = typeof orderStatusHistory.$inferInsert;
